import React from 'react';

import styles from './PromotionItem.module.scss';
import {resolveMediaUrl} from "../../../configs/urls";

// Format an ISO datetime to DD.MM.YYYY, or null when empty/invalid.
const formatDate = (value) => {
    if (!value) return null;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    return date.toLocaleDateString('uk-UA', {day: '2-digit', month: '2-digit', year: 'numeric'});
};

const PromotionItem = ({promotion = {}}) => {
    const {title, description, image, starts_at, ends_at, discount_percent} = promotion;

    const startDate = formatDate(starts_at);
    const endDate = formatDate(ends_at);
    const dateRange = [startDate, endDate].filter(Boolean).join(' – ');

    // discount_percent comes straight from the API; surface it as a badge when
    // present (treat 0 / null / '' as "no badge").
    const hasDiscount = discount_percent !== null && discount_percent !== undefined
        && discount_percent !== '' && Number(discount_percent) > 0;

    const coverImage = resolveMediaUrl(image);

    return (
        <div className={styles.promotionItem}>
            {/* Cover is a branded indigo gradient by default; a real admin image
                (when present) is layered underneath the gradient overlay so any
                photo blends in and the text stays legible. */}
            <div className={styles.promotionItem_photo}>
                {coverImage &&
                    <img className={styles.promotionItem_photo_img} src={coverImage} alt={title || 'promotion'}/>}
                <span className={styles.promotionItem_photo_overlay}/>

                {hasDiscount
                    ? (
                        <div className={styles.promotionItem_photo_hero}>
                            <span className={styles.promotionItem_photo_heroValue}>
                                −{discount_percent}<span className={styles.promotionItem_photo_heroUnit}>%</span>
                            </span>
                            <span className={styles.promotionItem_photo_heroLabel}>знижка</span>
                        </div>
                    )
                    : <span className={styles.promotionItem_photo_brand}>Акція Kova</span>}
            </div>

            <div className={styles.promotionItem_description}>
                <div className={styles.promotionItem_description_top}>
                    <h3 className={styles.title}>{title}</h3>
                    {description && <p className={styles.subtitle}>{description}</p>}
                </div>

                <div className={styles.promotionItem_description_footer}>
                    {dateRange &&
                        <span className={styles.promotionItem_description_date}>{dateRange}</span>}

                    {/* The whole card already opens ModalDiscount via its parent's
                        onClick — this CTA just lets the click bubble up, no extra
                        wiring needed. */}
                    <button type="button" className={styles.promotionItem_description_cta}>
                        Отримати промокод
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PromotionItem;
